import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Form,
  Badge,
  Spinner,
  Modal,
} from "react-bootstrap";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";

/* ================= IMAGE HELPER ================= */
const getImageUrl = (img) => {
  if (!img) return "/no-image.png";


  const image = Array.isArray(img) ? img[0] : img;

  // agar already full url hai
  if (typeof image === "string" && image.startsWith("http")) {
    return image;
  }


  return `https://api.bigfresh.in/uploads/${image}`;
};

const OrderHistory = ({userData}) => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [focusedOrder, setFocusedOrder] = useState(null);

  // Detail modal
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);

  // Update modal
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [updatingOrder, setUpdatingOrder] = useState(null);
  const [newStatus, setNewStatus] = useState("Select");
  const [updating, setUpdating] = useState(false);
   const [terms, setTerms] = useState( "");

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      const res = await axios.get("https://api.bigfresh.in/order");
      setOrders(res.data.orderData || []);

    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString("en-IN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const handleSearch = (value) => {
    setSearchTerm(value);
    if (!value.trim()) {
      setFocusedOrder(null);
      return;
    }
    const match = orders.find((o) =>
      String(o.id || o._id).includes(value)
    );
    setFocusedOrder(match ? match.id || match._id : "not-found");
  };

  const handleViewDetail = (order) => {
    setSelectedOrder(order);
    setShowDetailModal(true);
  };



  const handleUpdateOrder = async () => {
    if (newStatus === "Select") {
      alert("Please select a status!");
      return;
    }

    try {
      setUpdating(true);

      await axios.put(
        `https://api.bigfresh.in/update-order-status/${updatingOrder.id}`,
        { status: newStatus },
        { headers: { "Content-Type": "application/json" } }
      );

      setOrders((prev) =>
        prev.map((o) =>
          (o.id || o._id) === (updatingOrder.id || updatingOrder._id)
            ? { ...o, status_order: newStatus }
            : o
        )
      );
      toast.success("Order status updated successfully!", { position: "top-center" });
      setShowUpdateModal(false);
      setUpdatingOrder(null);
      fetchOrders();

    } catch (error) {
      console.error(error.response?.data || error);
      toast.error("Failed to update order", { position: "top-center" });
    } finally {
      setUpdating(false);
    }
  };


   useEffect(() => {
   
    fetchTerms();
  }, [userData]);

 const fetchTerms = async () => {
      if (!userData?.id) return;

      try {
        const response = await axios.get(`https://api.bigfresh.in/get-term-condition/${userData.id}`);
        setTerms(response.data.bank_name || "");
      } catch (error) {
        console.error("Failed to fetch terms:", error);
        setTerms(""); 
      }
    };

  const parseItems = (items) => {
    if (!items) return [];
    if (typeof items === "string") {
      try {
        const parsed = JSON.parse(items);
        return Array.isArray(parsed) ? parsed : [];
      } catch {
        return [];
      }
    }
    return Array.isArray(items) ? items : [];
  };

  const handleOpenUpdate = (order) => {
    setSelectedOrder(order);
    setNewStatus(order.order_status_mode);
    setShowUpdateModal(true);
    setUpdatingOrder(order);
  };

  return (
    <>
      <h4 className="mb-3 text-success text-center fw-bold">
        Order History
      </h4>

      <Container fluid className="py-3">
        <Row className="mb-3">
          <Col md={4}>
            <Form.Control
              type="text"
              placeholder="Search by Order ID"
              value={searchTerm}
              onChange={(e) => handleSearch(e.target.value)}
            />
          </Col>
        </Row>

        {loading ? (
          <div className="text-center py-5">
            <Spinner animation="border" variant="success" />
          </div>
        ) : focusedOrder === "not-found" ? (
          <p>No results found</p>
        ) : (
          orders.map((o) => {
            const orderId = o.id || o._id;
            const items = parseItems(o.items);
            const isVerified =
              o.order_status_mode?.toLowerCase().includes("Delivered");

            return (
              <Card
                key={orderId}
                className={`mb-3 ${focusedOrder === orderId
                  ? "border-success shadow"
                  : ""
                  }`}
              >
                <Card.Header className="d-flex justify-content-between align-items-center">
                  <h5 className="mb-0">Order ID: {orderId}</h5>
                  {/* <Badge bg={isVerified ? "success" : "warning"}>
                    {isVerified ? "Order Verified" : "Verify Now"}
                  </Badge> */}
                </Card.Header>

                <Card.Body>
                  <Row className="mb-2">
                    <Col md={4}>📅 {formatDate(o.date)}</Col>
                    <Col md={4}>💳 Payment: ₹{o.payment}</Col>
                    <Col md={4}>📦 Status: {o.order_status_mode}</Col>
                  </Row>



           

                  <Row className="mb-3">
  {o.items ? (() => {
    let itemsArray = [];
    try {
      itemsArray = JSON.parse(o.items);
    } catch (err) {
      console.error("Invalid JSON in items:", err);
    }

    if (itemsArray.length === 0) {
      return <p className="text-danger">No items found</p>;
    }

    return itemsArray.map((item, idx) => (
      <Col key={idx} xs={6} sm={4} md={3} lg={2} className="mb-2">
        <Card className="text-center">
          <Card.Img
            variant="top"
            src={
              item.img
                ? `https://api.bigfresh.in/uploads/${item.img.split(",")[0].trim()}`
                : "/no-image.png"
            }
            onError={(e) => { e.target.src = "/no-image.png"; }}
            style={{ height: "80px", objectFit: "cover" }}
          />
          <Card.Body className="p-1">
            <small>{item.product_name}</small>
          </Card.Body>
        </Card>
      </Col>
    ));
  })() : (
    <p className="text-danger">No items found</p>
  )}
</Row>


                  <div className="d-flex gap-2">
                    <Button
                      variant="success"
                      onClick={() => handleViewDetail(o)}
                    >
                      View Detail
                    </Button>
                    <Button
                      variant="primary"
                      onClick={() => handleOpenUpdate(o)}
                    >
                      Update Status
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            );
          })
        )}



<Modal
  show={showDetailModal}
  onHide={() => setShowDetailModal(false)}
  centered
  size="lg"
>
  <Modal.Header closeButton>
    <Modal.Title>
      Order Invoice - {selectedOrder?.id || selectedOrder?._id}
    </Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <div id="printOrderModal">
      {selectedOrder && (() => {
        let itemsArray = [];
        try { itemsArray = JSON.parse(selectedOrder.items || "[]"); } 
        catch (err) { console.error(err); }

        const grandTotal = itemsArray.reduce(
          (total, item) => total + (item.item_qty || 0) * (item.sell_price || 0),
          0
        );

        return (
          <>
      
            <div className="row mb-3">
              <div className="col-md-6">
                📅 <strong>Order Date:</strong> {formatDate(selectedOrder.date)}
              </div>
              <div className="col-md-6">
                📦 <strong>Order Status:</strong> {selectedOrder.order_status_mode}
              </div>
            </div>

      
            <div className="mb-3">
              <h5>Seller Details</h5>
              <p className="mb-0">Big Fresh Mart</p>
              <p className="mb-0">1/11, GIDS, VAPI - 396191 (Gujarat)</p>
            </div>

   
            <div className="row mb-3">
              <div className="col-md-6">
                <h5>Customer Details</h5>
                <p className="mb-0"><strong>Name:</strong> {selectedOrder.name}</p>
                <p className="mb-0"><strong>Phone:</strong> {selectedOrder.phone}</p>
                <p className="mb-0"><strong>Email:</strong> {selectedOrder.email}</p>
              </div>
              <div className="col-md-6">
                <h5>Delivery Address</h5>
                <p>{selectedOrder.address}</p>
              </div>
            </div>

            {/* Order Items Table */}
            <h5>Order Items</h5>
            <div className="table-responsive">
                    <table className="table table-bordered mb-3">
              <thead>
                <tr className="table-info">
                  <th>SN</th>
                  <th>Name</th>
                  <th>Qty</th>
                  <th>MRP</th>
                  <th>GST </th>
                  <th>Sell Price</th>
                  <th>Sub Total</th>
                </tr>
              </thead>
              <tbody>
                {itemsArray.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item.product_name}</td>
                  
                    <td>{item.item_qty}</td>
                    <td>{item.mrp}</td>
                      <td> {item.tax} </td>
                    <td>{item.sell_price}</td>
                    <td>{(item.item_qty || 0) * (item.sell_price || 0)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
         

            {/* Payment & Grand Total */}
            <div className="row mb-2">
              <div className="col-md-6">
                <p className="mb-0"><strong>Payment Mode:</strong> {selectedOrder.mode}</p>
                <p className="mb-0"><strong>Payment Status:</strong> {selectedOrder.payment_status || "Pending"}</p>
              </div>
              <div className="col-md-6 text-end">
                <h6>Grand Total: ₹{grandTotal}</h6>
              </div>
            </div>

         
<div className="mt-4 d-flex justify-content-end"> 
  <div style={{ borderTop: "1px solid #000", width: "200px", textAlign: "center" }}>
    Signature
  </div>
</div>

   
        
             <div>
      <h6>Terms & Conditions</h6>
      {terms ? (
        <p>{terms}</p>
      ) : (
        <p>No terms & conditions available.</p>
      )}
    </div>
          </>
        );
      })()}
    </div>
  </Modal.Body>

  {/* Print / Save PDF Button */}
  <Modal.Footer>
    <Button
      onClick={() => {
        if (!selectedOrder) return;
        const printWindow = window.open("", "", "height=800,width=1000");

        let itemsArray = [];
        try { itemsArray = JSON.parse(selectedOrder.items || "[]"); } 
        catch (err) { console.error(err); }

        const grandTotal = itemsArray.reduce(
          (total, item) => total + (item.item_qty || 0) * (item.sell_price || 0),
          0
        );

        const rowsHTML = itemsArray.map((item, index) => `
          <tr>
            <td>${index + 1}</td>
            <td>${item.product_name || ""}</td>
            <td>${item.item_qty || 0}</td>
            <td>${item.mrp || 0}</td>
             <td>${item.tax || 0}</td>
            <td>${item.sell_price || 0}</td>
            <td>${(item.item_qty || 0) * (item.sell_price || 0)}</td>
          </tr>
        `).join("");

        // printWindow.document.write(`
        //   <html>
        //     <head>
        //       <title>Invoice - BigFresh Mart</title>
        //       <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.1/dist/css/bootstrap.min.css">
        //       <style>
        //         body { font-family: Arial, sans-serif; padding: 20px; }
        //         .invoice-header { text-align: center; margin-bottom: 20px; }
        //         table { width: 100%; border-collapse: collapse; margin-bottom: 20px; }
        //         table th, table td { border: 1px solid #000; padding: 8px; text-align: left; }
        //         table th { background-color: #f2f2f2; }
        //         .grand-total { text-align: right; font-weight: bold; font-size: 1.1em; }
        //         .signature { border-top: 1px solid #000; width: 200px; margin-top: 40px; }
        //       </style>
        //     </head>
        //     <body>
        //       <div class="invoice-header">
        //         <h2>Order Invoice</h2>
        //       </div>

        //       <p><strong>Order Date:</strong> ${formatDate(selectedOrder.date)}</p>
        //       <p><strong>Order Status:</strong> ${selectedOrder.order_status_mode}</p>

        //       <h5>Seller Details</h5>
        //       <p>Big Fresh Mart</p>
        //       <p>1/11 GIDS, VAPI, Gujarat</p>

        //       <div class="d-flex justify-content-between mb-3">
        //         <div>
        //           <h5>Customer Details</h5>
        //           <p>Name: ${selectedOrder.name}</p>
        //           <p>Phone: ${selectedOrder.phone}</p>
        //           <p>Email: ${selectedOrder.email}</p>
        //         </div>
        //         <div>
        //           <h5>Delivery Address</h5>
        //           <p>${selectedOrder.address}</p>
        //         </div>
        //       </div>

        //       <h5>Order Items</h5>
        //       <table class="table table-bordered">
        //         <thead>
        //           <tr>
        //             <th>SN</th>
        //             <th>Item</th>
        //             <th>Qty</th>
        //             <th>MRP</th>
        //             <th>Sell Price</th>
        //             <th>Total</th>
        //           </tr>
        //         </thead>
        //         <tbody>
        //           ${rowsHTML}
        //         </tbody>
        //       </table>

        //       <div class="d-flex justify-content-between mb-3">
        //         <div>
        //           <p><strong>Payment Mode:</strong> ${selectedOrder.mode}</p>
        //           <p><strong>Payment Status:</strong> ${selectedOrder.payment_status || "Pending"}</p>
        //         </div>
        //         <div class="grand-total">
        //           <strong>Grand Total: ₹${grandTotal}</strong>
        //         </div>
        //       </div>

        //       <div class="signature">Signature</div>

        //       <h6>Terms & Conditions</h6>
        //       <p>All sales are subject to our standard terms and conditions. Goods once sold will not be taken back. Payment must be completed as per the agreed terms.</p>
        //     </body>
        //   </html>
        // `);



     printWindow.document.write(`
<html>
  <head>

    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.1/dist/css/bootstrap.min.css">
    <style>
      body { font-family: 'Roboto', sans-serif; padding: 15px; }
      .invoice-header { text-align: Right; margin-bottom: 20px; }
      table { width: 100%; border-collapse: collapse; margin-bottom: 20px; }
      table th, table td { border: 1px solid #000; padding: 8px; text-align: left; }
      table th { background-color: #f2f2f2; }
      .grand-total { text-align: right; font-weight: bold; font-size: 1.1em; }
      .signature { border-top: 1px solid #000; width: 200px; text-align: center; margin-top: 40px; }
      p { margin-top: 0; margin-bottom: 4px; } /* Tighten spacing for all paragraphs */
    </style>
  </head>
  <body>
    <div class="invoice-header">
      <h2>Invoice</h2>
    </div>

    <!-- Order Info -->
<div style="display: flex; justify-content: space-between; margin-bottom: 10px;">
  <p style="margin: 0;">
    <strong>Invoice Date:</strong> ${formatDate(selectedOrder.date)}
  </p>

  <p style="margin: 0; text-align: right;">
    <strong>Order Status:</strong> ${selectedOrder.order_status_mode}
  </p>
</div>

    <br/>
  

    <!-- Seller Info -->
<!-- Top Section -->
<div style="display: flex; justify-content: space-between; align-items: flex-start;">

  <!-- Left Side -->
 

  <!-- Right Side -->
  <div style="width: 48%; ">
    <p><strong>Bill From</strong></p>
    <p>Big Fresh Mart</p>
     <p> 8755901970</p>
    <p>1/11, GIDS, VAPI - 396191 (Gujarat)</p>
   
  </div>

   <div style="width: 48%; text-align: right;">
    <p><strong>Bill To</strong></p>
    <p> ${selectedOrder.name}</p>
    <p> ${selectedOrder.phone}</p>
    <p  style="word-wrap: break-word; overflow-wrap: break-word;">${selectedOrder.address}</P>
    <br/>

  
  
  </div>

</div>

    <br/>

    <!-- Order Items -->
     <p > <strong>Product Detail</strong> </p>
    <table class="table table-bordered">
      <thead>
        <tr>
          <th>SN</th>
          <th>Item</th>
          <th>Qty</th>
          <th>MRP</th>
          <th>Tax </th>
          <th>Sell Price</th>
          <th>Sub Total</th>
        </tr>
      </thead>
      <tbody>
        ${rowsHTML}
      </tbody>
    </table>


<div style="margin-bottom: 10px; display: flex; justify-content: flex-end;">
  <div style="font-size: 1.4em; font-weight: bold;">
    Grand Total: ₹${grandTotal}
  </div>
</div>
<br/>

<!-- Payment Details (Left Side, Next Row) -->
<div style="margin-bottom: 10px; line-height: 1.2;">
  <p style="margin: 0;"><strong>Payment Mode:</strong> ${selectedOrder.mode}</p>
  <p style="margin: 0;"><strong>Payment Status:</strong> ${selectedOrder.payment_status || "Pending"}</p>
</div>

    <!-- Signature -->
    <div style="margin-bottom: 10px; display: flex; justify-content: flex-end;">
      <div class="signature">Signature</div>
    </div>

    <br/>

    <!-- Terms & Conditions -->
            <div>
      <h3>Terms & Conditions</h3>
     <p>
        ${terms ? terms.replace(/\n/g, "<br/>") : "No terms & conditions available."}
      </p>
    </div>
  </body>
</html>
`);

        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        printWindow.close();
      }}
    >
      Save as PDF
    </Button>
  </Modal.Footer>
</Modal>


        <Modal
          show={showUpdateModal}
          onHide={() => setShowUpdateModal(false)}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Update Order Status</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Select
              value={newStatus || selectedOrder?.order_status_mode || "Select"}
              onChange={(e) => setNewStatus(e.target.value)}
            >
              <option value="Select">Select</option>
              <option value="Dispatch">Dispatch</option>
              <option value="Shift Dispatch">Shift Dispatch</option>
              <option value="Out For Delivery">Out For Delivery</option>
              <option value="Delivered">Delivered</option>
            </Form.Select>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowUpdateModal(false)}
            >
              Cancel
            </Button>
            <Button
              variant="danger"
              onClick={handleUpdateOrder}
              disabled={updating}
            >
              {updating ? "Updating..." : "Update"}
            </Button>
          </Modal.Footer>
        </Modal>


        <ToastContainer />
      </Container>
    </>
  );
};

export default OrderHistory;
